import { Input } from 'antd';
import styled from 'styled-components';

import CommonButton from '~/UI/components/atoms/CommonButton';

export const Title = styled.div(({ theme }) => ({
  fontSize: theme.typography.size24,
  fontWeight: 'bold',
  fontFamily: theme.typography.family.arial,
  color: theme.palette.artichoke,
  marginBottom: '20rem',
}));

export const FooterButton = styled(CommonButton)(({ theme }) => ({
  fontSize: theme.typography.size20,
}));

export const TicketInput = styled(Input)(() => ({
  marginBottom: '20rem',
}));

export const Notification = styled.div(() => ({
  marginBottom: '20rem',
}));

export const ErrorText = styled.span(({ theme }) => ({
  color: theme.palette.red,
}));
